import React, { useState } from "react";
import moderatorBlogStyles from "src/Assets/css/Moderator/ModeratorBlog.module.css";
import { Menu, MenuItem } from "@szhsin/react-menu";
import { PiDotsThreeBold } from "react-icons/pi";
import IconButton from "@material-ui/core/IconButton";
import ModeratorBlogReusableAlertPopup from "./ModeratorBlogReusableAlertPopup";
import API from "../../../network";
import {
  capitalizeFirstLetter,
  ignoreSpacesAndUrlsFromMsg,
} from "src/Utils/commonUtils";

import editIcon from "src/Assets/images/edit.svg";
import deleteIcon from "src/Assets/images/Delete.svg";

const ArchivedBlogs = (props) => {
  const { archivedBlogs, setArchivedBlogs } = props;

  // Control archived blog actions
  const [showPostBlogPopup, setShowPostBlogPopup] = useState(false);
  const [showDeleteBlogPopup, setShowDeleteBlogPopup] = useState(false);

  // Store selected archived blog
  const [selectedBlog, setSelectedBlog] = useState(null);

  // Track archived blog edit mode
  const [isEditingArchivedBlog, setIsEditingArchivedBlog] = useState(false);

  // Editable archived blog text
  const [editedBlogText, setEditedBlogText] = useState("");
  const [editedCharCount, setEditedCharCount] = useState(0);

  // Loading state for archived blog actions
  const [isProcessingBlog, setIsProcessingBlog] = useState(false);

  console.log(`archivedBlogs in archivedBlogs component:`, archivedBlogs);
  // Enable edit mode before reposting archived blog
  const onPostBlog = (blog) => {
    setSelectedBlog(blog);
    setShowPostBlogPopup(true);
  };
  // Open delete confirmation popup
  const onDeleteBlog = (blog) => {
    setSelectedBlog(blog);
    setShowDeleteBlogPopup(true);
  };

  const onContinuePostBlog = () => {
    setShowPostBlogPopup(false);

    const initialText = selectedBlog?.blog || "";
    setEditedBlogText(initialText);
    setEditedCharCount(ignoreSpacesAndUrlsFromMsg(initialText).msgLength);
    setIsEditingArchivedBlog(true);
  };

  const onEditedBlogTextChange = (e) => {
    const textValue = e.target.value;
    const formattedValue = capitalizeFirstLetter(textValue);
    const { msgLength } = ignoreSpacesAndUrlsFromMsg(formattedValue);
    setEditedCharCount(msgLength);
    setEditedBlogText(formattedValue);
  };

  // Cancel archived blog editing
  const onCancelEditArchivedBlog = () => {
    setIsEditingArchivedBlog(false);
    setSelectedBlog(null);
    setEditedBlogText("");
    setEditedCharCount(0);
  };

  // Close repost popup
  const onCancelPostBlog = () => {
    setShowPostBlogPopup(false);
    setSelectedBlog(null);
  };

  // Close delete popup
  const onCancelDeleteBlog = () => {
    setShowDeleteBlogPopup(false);
    setSelectedBlog(null);
  };

  // Repost archived blog
  const onConfirmPostBlog = async () => {
    try {
      if (!editedBlogText.trim() || editedCharCount > 280) return;

      setIsProcessingBlog(true);

      const formData = new FormData();
      formData.append("blogText", editedBlogText.trim());
      formData.append("tenantid", selectedBlog?.TenantID);

      const response = await API.postBlog(formData);

      const statusMessage = response?.data?.Status;

      if (statusMessage) {
        alert(statusMessage);
      }
      
      setSelectedBlog(null);
      setEditedBlogText("");
      setEditedCharCount(0);
      setIsEditingArchivedBlog(false);
    } catch (error) {
      console.error("Error reposting archived blog:", error);
    } finally {
      setIsProcessingBlog(false);
    }
  };

  // Delete archived blog
  const onConfirmDeleteBlog = async () => {
    try {
      setIsProcessingBlog(true);

      const formData = new FormData();
      formData.append("tenantid", selectedBlog?.TenantID);
      formData.append("blogId", selectedBlog?.blogId);
      formData.append("task", "delete");

      const response = await API.deleteArchivedBlogs(formData);

      const statusMessage = response?.data?.Status;

      if (!statusMessage) return;

      if (statusMessage === "blog deleted successfully") {
        // Remove deleted blog from UI immediately
        setArchivedBlogs((prevBlogs) =>
          prevBlogs.filter((blog) => blog.blogId !== selectedBlog?.blogId),
        );

        // Close popup and clear selected blog
        setShowDeleteBlogPopup(false);
        setSelectedBlog(null);
      }

      alert(statusMessage);
    } catch (error) {
      console.error("Error deleting archived blog:", error);
      alert("Failed to delete blog.");
    } finally {
      setIsProcessingBlog(false);
    }
  };

  if (!archivedBlogs?.length) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: 100,
        }}
      >
        No archived blogs found.
      </div>
    );
  }
  return (
    <>
      {archivedBlogs?.map((blogItem) => (
        <div
          key={blogItem.blogId}
          className={moderatorBlogStyles.archivedBlogWrapper}
        >
          <div className={moderatorBlogStyles.archivedContainer}>
            {!(
              isEditingArchivedBlog && selectedBlog?.blogId === blogItem.blogId
            ) && (
              <div className={moderatorBlogStyles.archivedActionDropDown}>
                <Menu viewScroll="close" reposition="auto" position="anchor"
                  menuButton={
                    <IconButton
                      style={{
                        padding: 0,
                        width: 30,
                        height: 30,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        outline: "none",
                      }}
                    >
                      <PiDotsThreeBold
                        fontSize={22}
                        color="rgba(0, 0, 0, 0.7)"
                      />
                    </IconButton>
                  }
                  transition
                  direction="bottom"
                  arrow
                  align="end"
                  menuStyle={{
                    backgroundColor: "white",
                    borderRadius: 20,
                    minWidth: "max-content",
                  }}
                >
                  <MenuItem onClick={() => onPostBlog(blogItem)}>
                    <div style={{ display: "flex", alignItems: "center", width: "100%", height: "100%", padding: "0.375rem 1.5rem", boxSizing: "border-box", cursor: "pointer", whiteSpace: "nowrap" }}>
                      <img src={editIcon} style={{ width: 18, height: 18, marginRight: 8, flexShrink: 0, objectFit: "contain" }} alt="" />
                      <span style={{ fontSize: 14, whiteSpace: "nowrap" }}>Post</span>
                    </div>
                  </MenuItem>

                  <MenuItem onClick={() => onDeleteBlog(blogItem)}>
                    <div style={{ display: "flex", alignItems: "center", width: "100%", height: "100%", padding: "0.375rem 1.5rem", boxSizing: "border-box", cursor: "pointer", whiteSpace: "nowrap" }}>
                      <img src={deleteIcon} style={{ width: 18, height: 18, marginRight: 8, flexShrink: 0, objectFit: "contain" }} alt="" />
                      <span style={{ fontSize: 14, whiteSpace: "nowrap" }}>Delete</span>
                    </div>
                  </MenuItem>
                </Menu>
              </div>
            )}

            {isEditingArchivedBlog &&
            selectedBlog?.blogId === blogItem.blogId ? (
              <>
                <textarea
                  value={editedBlogText}
                  onChange={onEditedBlogTextChange}
                  className={moderatorBlogStyles.blogPostTextArea}
                  rows={5}
                />

                <div className={moderatorBlogStyles.charCountContainer}>
                  <label
                    style={{
                      color: editedCharCount > 280 ? "red" : "#666",
                    }}
                  >
                    {editedCharCount}
                  </label>
                  <label>/280</label>
                </div>

                <div className={moderatorBlogStyles.buttonContainer}>
                  <button
                    className={moderatorBlogStyles.postButton}
                    disabled={
                      !editedBlogText.trim() ||
                      editedCharCount > 280 ||
                      isProcessingBlog
                    }
                    onClick={onConfirmPostBlog}
                  >
                    {isProcessingBlog ? "Posting..." : "Post"}
                  </button>

                  <button
                    className={moderatorBlogStyles.cancelButton}
                    onClick={onCancelEditArchivedBlog}
                    disabled={isProcessingBlog}
                  >
                    Cancel
                  </button>
                </div>
              </>
            ) : (
              <div className={moderatorBlogStyles.archivedBlogContent}>
                {blogItem.blog}
              </div>
            )}
          </div>
          <span className={moderatorBlogStyles.archivedDate}>
            Archived {blogItem.created_date} ago
          </span>
        </div>
      ))}

      <ModeratorBlogReusableAlertPopup
        open={showPostBlogPopup}
        title="Post Blog"
        message="Posting this blog will archive your current blog"
        onClose={onCancelPostBlog}
        onContinue={onContinuePostBlog}
      />

      <ModeratorBlogReusableAlertPopup
        open={showDeleteBlogPopup}
        title="Delete Blog"
        message="Are you sure you want to delete this archived blog?"
        onClose={onCancelDeleteBlog}
        onContinue={onConfirmDeleteBlog}
      />
    </>
  );
};

export default ArchivedBlogs;
